import { useCallback, useEffect, useState } from 'react';

import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const useUserInfo = () => {
  const [state, setState] = useState({ loaded: false, user: null });

  const fetchUser = useCallback(async () => {
    const stored = await StorageHandler.load(storageKeys.user);
    const user = stored && stored.response ? stored.response : null;
    setState({ loaded: true, user });
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return { ...state, refresh: fetchUser };
};

export default useUserInfo;
